module.exports = "/_next/static/images/no-result-fr-b99ec0277193ef7a03f7b08d6a33b7b4.svg";